import { Component } from '@angular/core';

import { navigation } from '../../_navigation';

@Component({
    selector: 'app-side-bar',
    templateUrl: './app-side-bar.component.html',
    styleUrls: ['./app-side-bar.component.scss']
})
export class AppSideBarComponent {

    public navigation = navigation;

    constructor() { }

}


// WEBPACK FOOTER //
// C:/Users/Willi/Source/Repos/Reservation01/scr/reservation.client/src/app/components/app-side-bar/app-side-bar.component.ts